export class RandomWildConstants {
    public static readonly PAUSE_BEFORE_SYMBOLS_DARKENING: number = 500;
    public static readonly DELAYS_BETWEEN_NEXT_FLIGHTS_LESSER_THAN_FOUR: number[] = [1000, 1500, 1750];
    public static readonly DELAYS_BETWEEN_NEXT_FLIGHTS_GREATER_THAN_THREE: number[] = [2000, 2250, 2500];
}
